import React from "react";
import { Link } from "react-router-dom";
import SectionTitle from "../../components/SectionTitle";
import brandLogo from "../../pages/home/components/img/brands/bff-logo.png"; 
import phoneImage from "../../pages/home/components/img/brands/BFF-phone-mockup.png";
import metric1 from "../../pages/home/components/img/brands/burger-1.jpg";
import metric2 from "../../pages/home/components/img/brands/burger-2.png";
import metric3 from "../../pages/home/components/img/brands/burger-3.jpg";
import menu1 from "../../pages/home/components/img/brands/burger-menu-1.png";
import menu2 from "../../pages/home/components/img/brands/burger-menu-2.png";
import menu3 from "../../pages/home/components/img/brands/burger-menu-3.png";
import deliveryPartners from "../../pages/home/components/img/brands/delivery-partners.png";
import ctaImage from "../../pages/home/components/img/brands/burger-cta-image.png";
import otherBrand1 from "../../pages/home/components/img/brands/brand-1.png";
import otherBrand2 from "../../pages/home/components/img/brands/brand-6.png";
import otherBrand3 from "../../pages/home/components/img/brands/brand-2.png";
import "./BFF.scss";
import videoFile from "../../pages/home/components/videos/Burger&Fast_Food_Promo_004.mp4"; // ✅ Correctly placed import

const BFF = () => {
  return (
    <div className="bff-page">
      
     {/* Hero Section */}
     <section className="hero-section">
        <div className="container text-center">
          <img src={brandLogo} alt="Bff Logo" className="brand-logo" />
          <h1>Bring  BFF to your area</h1>

          {/* Video Section */}
          <div className="video-container">
            <video className="hero-video" controls>
              <source src={videoFile} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>

          
        </div>
      </section>
 

     {/* Business Value Proposition Section */}
<section className="business-section">
  <div className="container">
    <div className="business-content">
      <img src={phoneImage} alt="Order Just Chicken Wings" className="phone-mockup" />
      <div className="business-text">
        <h2>Satisfy Your Burger Cravings</h2>
        <p>
		Turn your kitchen into a burger & fries powerhouse with zero upfront costs. Add BFF to your menu and watch your profits grow!
        </p>
      </div>
    </div>
  </div>
</section>


      {/* Key Metrics / Achievements Section */}
      <section className="metrics-section">
        <div className="container text-center">
          <div className="metrics">
            <img src={metric1} alt="Sales" />
            <p>500K+ Burgers Served</p>
          </div>
          <div className="metrics">
            <img src={metric2} alt="Customers" />
            <p>A Flavor You Can’t Resist!</p>
          </div>
          <div className="metrics">
            <img src={metric3} alt="Years in Business" />
            <p>3 Years of Success</p>
          </div>
        </div>
      </section>

      {/* Testimonial Section */}
      <section className="testimonial-section">
        <div className="container text-center">
          <blockquote>
		  "Adding BFF to my restaurant was the best decision! Our burgers became an instant hit, and revenue skyrocketed!"
          </blockquote>
          <cite>— Sarah, Miami Restaurant Owner</cite>
        </div>
      </section>

      {/* Popular Menu Items / Featured Dishes Section */}
      <section className="menu-section">
        <div className="container">
          <h2>Fan Favorites</h2>
          <div className="menu-items">
            <div className="menu-card">
              <img src={menu1} alt="Buffalo Wings" />
              <h3>Juicy Double Cheddar Burger</h3>
              <p>Two perfectly grilled beef patties, melted cheddar cheese, and fresh toppings on a toasted brioche bun. A flavor-packed bite in every bite!</p>
            </div>
            <div className="menu-card">
              <img src={menu2} alt="Garlic Parmesan Wings" />
              <h3>Golden Fries with a Buttery Parmesan Kick</h3>
              <p>Hand-cut crispy fries tossed in rich garlic butter and topped with shredded parmesan for the ultimate indulgence.</p>
            </div>
            <div className="menu-card">
              <img src={menu3} alt="BBQ Wings" />
              <h3>The Ultimate Classic Burger</h3>
              <p>A juicy flame-grilled beef patty stacked with crisp lettuce, fresh tomatoes, and melted cheese on a sesame seed bun.</p>
            </div>
          </div>
        </div>
      </section>

   {/* Delivery Platforms Section */}
<section className="delivery-section">
  <div className="container">
    <div className="text-content">
      <h2>Available on Hey Jag Customer App</h2>
      <p>
        BFF is available exclusively on <strong>Hey Jag customer App</strong>, 
        the revolutionary delivery platform that offers lower fees, better service, 
        and direct support for restaurants. Customers can easily order their favorite 
        wings with faster delivery and seamless tracking.
      </p>
      <Link to="/delivery" className="cmn-btn">
          <span>Learn More</span></Link>
    </div>
    <div className="delivery-logos">
      <img src={deliveryPartners} alt="Delivery Partners on Hey Jag" />
      
    </div>
  </div>
</section>



     {/* Call-to-Action (CTA) Section */}
<section className="cta-section">
  <div className="container text-center">
    <h2>That’s a Wrap!</h2>
    <p>Start running BFF from your kitchen today.</p>
    <img src={ctaImage} alt="Join Now" className="cta-image" />  {/* Image with reduced size ✅ */}
    <a
      href="https://calendar.google.com/calendar/appointments/schedules/AcZssZ3bx6kbQqtu-wVjgCL2H26Z16mSbWqgSAt5J-bVWbFdx6o_jy0Knt21nnGAvFeQfaJpx7LtZld7?gv=true"
      target="_blank"
      rel="noopener noreferrer"
      className="cmn-btn"
    >
      <span>Take The First Step</span>
    </a>
  </div>
</section>


      {/* Explore Other Brands Section */}
      <section className="other-brands-section">
        <div className="container">
          <h2>Not your flavor? Explore other brands:</h2>
          <div className="other-brands">
            <div className="brand-card">
              <img src={otherBrand1} alt="Brand 1" />
              <h3>Just Chicken Wings</h3>
              <Link to="/brands/just-chicken-wings" className="cmn-btn">
              <span>LEARN MORE</span></Link>
            </div>
            <div className="brand-card">
                <img src={otherBrand2} alt="Brand 3" />
                <h3>NYPD Pizza</h3>
                <Link to="/brands/nypd-pizza" className="cmn-btn">
                <span>LEARN MORE</span></Link>
              </div>
            <div className="brand-card">
              <img src={otherBrand3} alt="Brand 3" />
              <h3>The Imperial Bamboo</h3>
              <Link to="/brands/the-imperial-bamboo" className="cmn-btn">
              <span>LEARN MORE</span></Link>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default BFF;